import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import api from '../../api/api'

export const get_customers = createAsyncThunk(
    'customer/get_customers',
    async ({ parPage, page, searchValue }, { rejectWithValue, fulfillWithValue }) => {
        try {
            const { data } = await api.get(`/admin/customers?page=${page}&&searchValue=${searchValue}&&parPage=${parPage}`, { withCredentials: true })
            return fulfillWithValue(data)
        } catch (error) {
            return rejectWithValue(error.response.data)
        }
    }
)

export const get_customer = createAsyncThunk(
    'customer/get_customer',
    async (customerId, { rejectWithValue, fulfillWithValue }) => {
        try {
            const { data } = await api.get(`/admin/customer/${customerId}`, { withCredentials: true })
            return fulfillWithValue(data)
        } catch (error) {
            return rejectWithValue(error.response.data)
        }
    }
)

export const customerReducer = createSlice({
    name: 'customer',
    initialState: {
        successMessage: '',
        errorMessage: '',
        loader: false,
        customers: [],
        customer: {},
        totalCustomers: 0
    },
    reducers: {
        messageClear: (state, _) => {
            state.errorMessage = ""
            state.successMessage = ""
        }
    },
    extraReducers: {
        [get_customers.fulfilled]: (state, { payload }) => {
            state.customers = payload.customers
            state.totalCustomers = payload.totalCustomers
        },
        [get_customer.fulfilled]: (state, { payload }) => {
            state.customer = payload.customerData
        }
    }
})

export const { messageClear } = customerReducer.actions
export default customerReducer.reducer
